import styled from 'styled-components'

export default styled.div`
  height: 52px;
  position: relative;
  color: white;
  text-align: left;
  padding: 6px 16px;
  border-${props => !!props.border ? props.border : 'bottom'}: ${props => !!props.border ? '1px solid #c7c7cc' : ''};
  display: flex;
  font-family: 'ABChanel PB Regular S', Arial, sans-serif;
  font-size: 12px;

  form {
    height: 100%;
  }

  input {
    height: 40px;
    width: 80%;
    font-size: 16px;
  }

  .react-search-bar__wrapper {
    flex: 1;
    background-color: #f6f6f6;
  }

  .react-search-bar__field {
    display: flex;
  }

  img {
    padding: 10px;
  }

  .cancel-btn {
    color: #767676;
    margin: auto;
    margin-left: 10px;
    min-width: 69px;
    text-align: center;
  }
`



// WEBPACK FOOTER //
// ./src/styles/SearchBar.js